// utils/firebaseAuth.js
import { getAuth, signOut } from "firebase/auth";
import toasted from "../config/toasted";

export const handleLogout = () => {
    const auth = getAuth();

    signOut(auth).then(() => {
        localStorage.clear();

        document.cookie.split(";").forEach((cookie) => {
            const eqPos = cookie.indexOf("=");
            const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
        });

        toasted.success("Logged out successfully!");

        setTimeout(() => {
            window.location.href = "/login";
        }, 300);
    });
};
